import { useState } from "react";
import { faqList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于久久视频官网与入口的常见疑问"
          desc="整理了大家最常问的几个问题，如果还有其他疑问，可以留意页面底部的反馈方式。"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen ? (
                  <p className="border-t border-background-200 px-5 py-4 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}